import { Avatar, Box, Button, Card, CardActions, CardContent, CardHeader, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { useConfig } from "../../contexts/ConfigContext";

type AdvisoryProps = {
  onAcknowledge: () => void;
};

export const ADVISORY_PREFERENCE_KEY = "showAdvisoryModal";

export default function Advisory({ onAcknowledge }: AdvisoryProps) {
  const config = useConfig();
  const logo = config?.logoPath;
  const title = config?.homePageTitle || "";
  const advisoryDescription = config?.homePageDescription || "";

  function handleAdvisoryModalVisibility() {
    const showAdvisory = JSON.parse(localStorage.getItem(ADVISORY_PREFERENCE_KEY) || "true");
    if (showAdvisory) {
      localStorage.setItem(ADVISORY_PREFERENCE_KEY, "false");
      return;
    }
    localStorage.setItem(ADVISORY_PREFERENCE_KEY, "true");
  }

  return (
    <Card
      sx={{
        maxHeight: "calc(100dvh - 8rem)",
        backgroundColor: "grey.800",
        width: "90%",
        padding: "2rem",
        borderRadius: "0.75rem",
        border: "1px solid",
        borderColor: "grey.700",
        boxShadow: "0 12px 16px -4px rgba(16, 24, 40, 0.08), 0 4px 6px -2px rgba(16, 24, 40, 0.03)",
        overflowY: "auto",
        "@media (min-width: 28.875rem)": {
          "&": {
            width: "27.0625rem",
            padding: "3.5rem 3.375rem 2.25rem 3.375rem"
          }
        }
      }}
      className='scroller'
      tabIndex={0}
    >
      <CardHeader
        avatar={logo && <Avatar src={logo} alt='logo' sx={{ height: "4.5rem", width: "4.5rem" }} />}
        title={title}
        sx={{ flexDirection: "column", alignItems: "flex-start", gap: "0.88rem", px: 0 }}
        titleTypographyProps={{ variant: "h2", fontWeight: 600, color: "grey.25" }}
      />

      <CardContent sx={{ px: 0 }}>
        <Typography sx={{ variant: "body1", color: "grey.100" }}>{advisoryDescription}</Typography>
      </CardContent>

      <CardActions sx={{ px: 0, flexDirection: "column", alignItems: "flex-start", "& > *": { marginLeft: "0 !important" } }}>
        <Box sx={{ marginBottom: "3.5rem" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: "grey.25",
                  "& .MuiSvgIcon-root": { fontSize: "1.5rem" },
                  "&.Mui-checked > svg": {
                    stroke: "currentcolor"
                  }
                }}
                onChange={handleAdvisoryModalVisibility}
              />
            }
            label={
              <Typography color='grey.100' variant='body1'>
                Don't show this again on this device
              </Typography>
            }
          />
        </Box>

        <Button
          disableElevation
          variant='contained'
          sx={{
            backgroundColor: "primary.main",
            color: "secondary.main",
            textTransform: "none",
            borderRadius: "0.5rem",
            padding: "0.5rem 0.75rem",
            borderColor: "primary.main"
          }}
          onClick={onAcknowledge}
        >
          I acknowledge / Continue
        </Button>
      </CardActions>
    </Card>
  );
}
